import React from 'react';
import classnames from 'classnames';
import makeIconName from '../../utils/makeIconName';
import makeBodyText from '../../utils/makeText';
import styles from './index.module.scss';
const Link = ({ id, label, withArrow, isSPA, navigateTo, isActive, isFullWidth, noUnderscore, arrowSize, onClick, onLocation, preventNavigation, isOpen, iconName, withIcon, iconPosition = 'left', withoutFill, arrowName = 'down', linkColor }) => {
    const _handleClick = (e) => {
        onClick && onClick(e);
        if (preventNavigation) {
            e.preventDefault();
            return;
        }
        if (isSPA) {
            e.preventDefault();
            onLocation(navigateTo);
        }
    };
    const getClasses = () => {
        const commonClasses = classnames({
            [styles.navigator]: true,
            [styles.withArrow]: withArrow,
            [styles.activeLink]: isActive,
            [styles.fullWidth]: isFullWidth,
            [styles.noUnderscore]: noUnderscore,
            [styles.isOpen]: isOpen,
            [styles.withIcon]: withIcon,
            [styles.withIconRight]: iconPosition === 'right',
            [styles.withoutFill]: withoutFill,
            [styles[linkColor]]: linkColor
        });
        return {
            linkClasses: classnames(commonClasses, styles.linkSPA),
            buttonClasses: classnames(commonClasses, styles.linkPure)
        };
    };
    const { linkClasses } = getClasses();
    const arrowSizeToAppear = arrowSize === 'S' ? 'x16' : 'x24';
    return (React.createElement("a", { id: id, key: id, onClick: (e) => _handleClick(e), href: navigateTo, className: linkClasses, "data-navigate-to": navigateTo },
        withIcon && (React.createElement("i", { className: classnames(makeIconName(iconName, 'x24'), styles.icon, {
                [styles.iconRight]: iconPosition === 'right'
            }) })),
        React.createElement("span", { className: `${makeBodyText('L')} ${styles.label}` }, label),
        withArrow && (React.createElement("i", { className: `${makeIconName(`arrow_${arrowName}`, arrowSizeToAppear)} ${styles.arrow}` }))));
};
export default Link;
